import TextareaAutosize from 'react-textarea-autosize';
import React, { forwardRef } from 'react';

const Textarea = (props, ref) => {
  return <TextareaAutosize ref={ref} {...props} />;
};

export default forwardRef(Textarea);
